import { render } from "./TabsLayout.vue?vue&type=template&id=3dd37f40"
import script from "./TabsLayout.ts?vue&type=script&lang=js&external"
export * from "./TabsLayout.ts?vue&type=script&lang=js&external"
/* custom blocks */
import block0 from "./TabsLayout.scss?vue&type=custom&index=0&blockType=scss&issuerPath=C%3A%5CBuildAgent%5Cwork%5C80844fdc646ab6fa%5Csrc%5Cresources-vue%5Cvue-custom-elements%5CTabsLayout%5CTabsLayout.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__